import React, { FC, useState } from 'react';
import { useLocation } from 'react-router-dom';

import { PATHS } from 'src/routes/paths';
import { Invest } from 'src/components/Invest';
import { Manage } from 'src/components/Manage/Manage';

import { SegmentButtonGroup } from '@/widgets/SegmentButtonGroup';
import { Faqs } from '@/widgets/FAQs';
import { useFetchVaults } from '@/shared/hooks/useFetchVaults';

export type Data = { [key: string]: string };

export enum Mode {
    INVEST = 'Invest',
    MANAGE = 'Manage',
}

export const groupList = [
    { text: Mode.INVEST, value: PATHS.VAULTS },
    { text: Mode.MANAGE, value: PATHS.VAULTS_MANAGE },
];

export const Vaults: FC = () => {
    const location = useLocation();

    const [currentMode, setCurrentMode] = useState<string | number>(location.pathname);

    useFetchVaults();

    const handleModeChange = (value: string | number) => {
        setCurrentMode(value);
    };

    return (
        <>
            <SegmentButtonGroup
                list={groupList}
                initialValue={currentMode}
                handleSegmentChanged={handleModeChange}
            />
            <div>
                {currentMode === PATHS.VAULTS && <Invest />}
                {currentMode === PATHS.VAULTS_MANAGE && <Manage />}
            </div>
            <Faqs />
        </>
    );
};
